import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  type TooltipProps,
} from 'recharts';

const brl = (v: number): string =>
  v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

const BRAND = '#7c3aed';
const MUTED = '#a1a1aa';
const LINE = '#1f1f23';

interface ProductBar {
  productName: string;
  mrrTotal: number;
  clientCount: number;
}

/** Story 12.11 — breakdown de MRR por produto (snapshot mais recente). */
export function MrrByProductChart({ data }: { data: ProductBar[] }) {
  return (
    <div className="overflow-hidden rounded-lg border border-line bg-panel">
      <div className="border-b border-line px-4 py-3">
        <h3 className="text-sm font-medium text-ink">MRR por produto</h3>
      </div>
      {data.length === 0 ? (
        <div className="py-12 text-center text-sm text-muted">Sem dados por produto ainda.</div>
      ) : (
        <div className="h-72 w-full p-4">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 12, right: 16, bottom: 4, left: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke={LINE} vertical={false} />
              <XAxis dataKey="productName" stroke={MUTED} fontSize={11} />
              <YAxis
                stroke={MUTED}
                fontSize={11}
                tickFormatter={(v) => brl(Number(v))}
                width={70}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: BRAND, fillOpacity: 0.08 }} />
              <Bar dataKey="mrrTotal" fill={BRAND} radius={[4, 4, 0, 0]} name="MRR" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}

function CustomTooltip({ active, payload, label }: TooltipProps<number, string>) {
  if (!active || !payload || payload.length === 0) return null;
  const item = payload[0]?.payload as ProductBar | undefined;
  return (
    <div className="rounded-md border border-line bg-panel px-3 py-2 text-xs shadow-md">
      <div className="font-medium text-ink">{String(label)}</div>
      <div className="mt-1 text-muted">
        MRR:{' '}
        <span className="font-mono tabular-nums text-ink">{brl(Number(payload[0]?.value))}</span>
      </div>
      {item && (
        <div className="text-muted">
          Clientes: <span className="font-mono tabular-nums text-ink">{item.clientCount}</span>
        </div>
      )}
    </div>
  );
}
